export class PermanentStorage {
    constructor(prefix) {
        this.prefix = prefix || "FTL_";
    }
    rawSet(rawKey, value) {
        return localStorage.setItem(rawKey, JSON.stringify(value));
    }
    rawGet(rawKey) {
        const item = localStorage.getItem(rawKey);
        return item ? JSON.parse(item) : null;
    }
    rawKeys() {
        return Object.keys(localStorage).filter((key) => key.search(this.prefix) !== -1);
    }
    getKey(key) {
        return `${this.prefix}${key}`;
    }
    get(key) {
        return this.rawGet(this.getKey(key));
    }
    set(key, value) {
        return this.rawSet(this.getKey(key), value);
    }
    values() {
        return this.rawKeys().map((rawKey) => this.rawGet(rawKey));
    }
    keys() {
        return this.rawKeys().map((rawKey) => rawKey.replace(this.prefix, ""));
    }
    clear(predicate) {
        if (predicate)
            return this.rawKeys()
                .filter(predicate)
                .forEach((rawKey) => localStorage.removeItem(rawKey));
        return this.rawKeys().forEach((rawKey) => localStorage.removeItem(rawKey));
    }
}
export default PermanentStorage;
//# sourceMappingURL=index.js.map